export default {"src":"/_next/static/media/bat.4ffcf551.svg","height":20,"width":20};